import type { CreateMockSource } from './types';

// Single place to declare mock data. In dev, each field announces itself the first time it's read
// (i.e. when it actually renders), so placeholder data is never silently shipped or mistaken for real.
const createMockSource: CreateMockSource = (namespace, values) => {
    if (!import.meta.env.DEV) {
        return values;
    }

    const logged = new Set<string>();

    return new Proxy(values, {
        get(target, key, receiver) {
            if (typeof key === 'string' && key in target && !logged.has(key)) {
                logged.add(key);
                console.warn(`[mock] ${namespace}.${key}`);
            }

            return Reflect.get(target, key, receiver);
        }
    });
};

export default createMockSource;
